__turbopack_context__.v({
  "card": "GifCard-module__EiZTcW__card",
  "media": "GifCard-module__EiZTcW__media",
  "overlay": "GifCard-module__EiZTcW__overlay",
  "overlayText": "GifCard-module__EiZTcW__overlayText",
});
